import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslationModule } from '@lib/translation';
import { SnDrawerModule } from '@lib/ui/drawer';
import { SnIconModule } from '@lib/ui/icon';

import { DebugPanelButtonComponent } from './components';
import { DebugPanelComponent } from './components/debug-panel.component';

@NgModule({
  imports: [
    CommonModule,
    SnDrawerModule,
    SnIconModule,
    MatIconModule,
    MatTooltipModule,
    MatSelectModule,
    FormsModule,
    TranslationModule,
    MatButtonModule,
  ],
  exports: [DebugPanelButtonComponent, DebugPanelComponent],
  declarations: [DebugPanelButtonComponent, DebugPanelComponent],
})
export class DebugPanelModule {}
